import { ListItemStack } from "@molecules"
import ListItemDivider from "@molecules/ListItem/ListItemDivider/ListItemDivider"

import FirstNameForm from "./FirstNameForm/FirstNameForm"
import LastNameForm from "./LastNameForm/LastNameForm"

export default function UserNamesForms() {
    return (
        <ListItemStack>
            <FirstNameForm />
            <ListItemDivider />
            <LastNameForm />
        </ListItemStack>
    )
}
